// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
._material-design-icon_u3tih_12 {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
._radioGroup_u3tih_20 {
  display: flex;
  flex-direction: column;
}
._radioGroup_u3tih_20:not(._radioGroup_buttonVariant_u3tih_24) .checkbox-content {
  max-width: unset !important;
}
._radioGroup__label_u3tih_28 {
  font-size: 1.2em;
  font-weight: bold;
  margin-inline-start: var(--border-radius-element);
}
._radioGroup__description_u3tih_34 {
  color: var(--color-text-maxcontrast);
  margin-block-end: var(--default-grid-baseline);
  margin-inline-start: var(--border-radius-element);
}
._radioGroup__wrapper_u3tih_40 {
  display: flex;
  flex-direction: column;
}
._radioGroup__wrapper_u3tih_40 > * {
  flex: 1 0 1px;
}
._radioGroup__label_u3tih_28 + ._radioGroup__wrapper_u3tih_40 {
  margin-block-start: var(--default-grid-baseline);
}
._radioGroup_buttonVariant_u3tih_24 ._radioGroup__wrapper_u3tih_40 {
  flex-direction: row;
  gap: var(--default-grid-baseline);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcRadioGroup-CNgjqqiP.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iDAAiD;AACnD;AACA;EACE,oCAAoC;EACpC,8CAA8C;EAC9C,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,gDAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,iCAAiC;AACnC","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n._material-design-icon_u3tih_12 {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n._radioGroup_u3tih_20 {\n  display: flex;\n  flex-direction: column;\n}\n._radioGroup_u3tih_20:not(._radioGroup_buttonVariant_u3tih_24) .checkbox-content {\n  max-width: unset !important;\n}\n._radioGroup__label_u3tih_28 {\n  font-size: 1.2em;\n  font-weight: bold;\n  margin-inline-start: var(--border-radius-element);\n}\n._radioGroup__description_u3tih_34 {\n  color: var(--color-text-maxcontrast);\n  margin-block-end: var(--default-grid-baseline);\n  margin-inline-start: var(--border-radius-element);\n}\n._radioGroup__wrapper_u3tih_40 {\n  display: flex;\n  flex-direction: column;\n}\n._radioGroup__wrapper_u3tih_40 > * {\n  flex: 1 0 1px;\n}\n._radioGroup__label_u3tih_28 + ._radioGroup__wrapper_u3tih_40 {\n  margin-block-start: var(--default-grid-baseline);\n}\n._radioGroup_buttonVariant_u3tih_24 ._radioGroup__wrapper_u3tih_40 {\n  flex-direction: row;\n  gap: var(--default-grid-baseline);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
